import { type IamApi } from '@/features/iam/api/iam-api'
import { type GetCurrentUserFn } from '@/features/iam'
import { computed } from 'mobx'

/**
 * Manages multi-factor authentication
 */
export class MultiFactorAuthStore {
  constructor(
    private readonly _api: IamApi,
    private readonly _getCurrentUser: GetCurrentUserFn,
  ) {}

  /**
   * Determine whether the user is enrolled in multi-factor authentication.
   */
  @computed
  get isUserEnrolled() {
    return this._getCurrentUser().multiFactorAuthenticationEnabled
  }

  /**
   * Gets an MFA enrollment URL.
   */
  async fetchEnrollmentUrl() {
    return this._api.authentication.enrollMFA().then((r) => r.enrollment_url)
  }
}
